/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoriaCaricoUpdateDTO
 */
export interface CategoriaCaricoUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof CategoriaCaricoUpdateDTO
     */
    codice: string;
    /**
     * 
     * @type {string}
     * @memberof CategoriaCaricoUpdateDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the CategoriaCaricoUpdateDTO interface.
 */
export function instanceOfCategoriaCaricoUpdateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "codice" in value;

    return isInstance;
}

export function CategoriaCaricoUpdateDTOFromJSON(json: any): CategoriaCaricoUpdateDTO {
    return CategoriaCaricoUpdateDTOFromJSONTyped(json, false);
}

export function CategoriaCaricoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoriaCaricoUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'codice': json['codice'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
    };
}

export function CategoriaCaricoUpdateDTOToJSON(value?: CategoriaCaricoUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'codice': value.codice,
        'descrizione': value.descrizione,
    };
}

